import React, { createContext, useContext, useEffect, useRef, useState, useCallback} from 'react';
import useWebSocketManager from '../api/webSocketManager';

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children, container_name=null }) => {
  const isInitialized = useRef(false);

  const onmessage = useCallback((event) => {

    console.log("WebSocket message received:", container_name, JSON.parse(event.data));
    const data = JSON.parse(event.data);
    if (data.type === "synch") setDocuments(data.files);
    else if (data.type === "upload")
      setDocuments((prev) => [
        ...prev,
        ...data.files.map((f, i) => ({ id: prev.length + i, name: f.name })),
      ]);
    else if (data.type === "delete")
      setDocuments((prev) =>
        prev.filter((doc) => !data.files.some((f) => f.name === doc.name))
      );
  }, [container_name]);

  const wsManager = useWebSocketManager(container_name ? `/listfiles?container=${container_name}` : '/listfiles', onmessage);
  const [documents, setDocuments] = useState([]);
    useEffect(() => {
        if (!isInitialized.current){
            isInitialized.current = true;
            wsManager.connect();
        }
        
        return () => {
            wsManager.disconnect();
            isInitialized.current = false;
        };
    // eslint-disable-next-line
    }, [container_name]); // IMPORTANT: intentionally empty deps here!

    
  return (
    <WebSocketContext.Provider value={{ documents, setDocuments }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocketContext = () => useContext(WebSocketContext);